/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Create_FailedInputs */

const en_admin_create_company_user_create_failed = /** @type {(inputs: Admin_Create_Company_User_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create user.`)
};

const de_admin_create_company_user_create_failed = /** @type {(inputs: Admin_Create_Company_User_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer konnte nicht angelegt werden.`)
};

/**
* | output |
* | --- |
* | "Failed to create user." |
*
* @param {Admin_Create_Company_User_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_create_failed = /** @type {((inputs?: Admin_Create_Company_User_Create_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Create_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_create_failed(inputs)
	return en_admin_create_company_user_create_failed(inputs)
});